import { useEffect, useState } from "react";
import API from "../../services/API";
import Avatar from "../Tools/Avatar";
import { Link } from "react-router-dom";
import { Link as A} from "@mui/material";
import Grid from "../Tools/Grid";
import moment from "moment/moment";
import { txt } from "../../services/translation";

export default function Contacts(){
    
    const [items, setItems] = useState(null)

    useEffect(() => {

        API.get('/companies/me/users')
            .then(r => setItems(r.data))

    }, [])


    return <>

        <Grid 
            id='contactsGrid'
            columns={columns}
            rows={items}
            toolbar
        />

    </>
}

const columns = [
    {
        field: 'avatar',
        headerName: txt('file'),
        width: 60,
        valueGetter: p => p.row.initials,
        renderCell: p => !p.rowNode.isAutoGenerated &&
            <Link to={`/company/contacts/${p.id}`}>
                <Avatar 
                    initials={p.row.initials} 
                    color={p.row.category?.color || 'grey'} 
                    size={36} 
                />
            </Link>,
        aggregable: false,
        groupable: false,
    },
    {
        field: 'firstName',
        headerName: txt('firstName'),
        width: 120,
        valueGetter: p => p.row.firstName,
        aggregable: false,
        groupable: false,
    },
    {
        field: 'lastName',
        headerName: txt('lastName'),
        width: 120,
        valueGetter: p => p.row.lastName,
        renderCell: p => p.value.toUpperCase(),
        aggregable: false,
        groupable: false,
    },
    {
        field: 'email',
        headerName: txt('email'),
        width: 240,
        valueGetter: p => p.row.email,
        renderCell: p => !p.row.isAutoGenerated &&
            <A href={`mailto:${p.row.email}`}>{p.row.email}</A>,
        aggregable: false,
        groupable: false,
    },
    {
        field: 'phone',
        headerName: txt('phone'),
        width: 120,
        valueGetter: p => p.row.phone,
        renderCell: p => !p.row.isAutoGenerated &&
            <A href={`tel:${p.row.phone}`}>{p.row.phone}</A>,
        aggregable: false,
        groupable: false,
    },
    {
        field: 'courses',
        headerName: txt('courses'),
        type: 'number',
        valueGetter: p => p.row.enrollmentsCount || 0,
        width: 100,
        aggregable: false,
        groupable: false,
    },
    {
        field: 'completion',
        headerName: txt('completion'),
        type: 'number',
        width: 120,
        valueGetter: p => p.row.completion || 0,
        aggregable: false,
        groupable: false,
    },
    {
        field: 'company',
        headerName: txt('company'),
        width: 200,
        valueGetter: p => p.row.company?.name,
        aggregable: false,
        groupable: false,
    },
    {
        field: 'createdAt',
        headerName: txt('createdAt'),
        width: 150,
        type: 'date',
        valueGetter: p => moment(p.row.createdAt).toDate(),
        renderCell: p => !p.rowNode.isAutoGenerated &&
            moment(p.row.createdAt).format('LLL'),
        aggregable: false,
        groupable: false,
    },
];


